import { Tooltip, TreeSelect } from "antd";

interface SelectTreeProps {
  value?: number;
  onChange?: (value: number | null) => void;
  list: any[];
  loading: boolean;
  style?: React.CSSProperties;
  planoContaFinanceiro?: boolean;
  centroCusto?: boolean;
  // Modo filtro: permite selecionar nos PAI/sinteticos (a expansao para as folhas descendentes e feita no backend).
  // Opt-in para nao afetar as telas de cadastro/rateio que so aceitam folhas.
  permiteSintetico?: boolean;
  props?: any;
}

const SelectTree = ({ value, onChange, list, loading, style, planoContaFinanceiro = false, centroCusto = false, permiteSintetico = false, props }: SelectTreeProps) => {
  const generateTree = (value: any[] = []) => {
    var retorno: any[] = [];
    value.map(({ filhos, ...props }: any) => {
      if (filhos?.length === 0) {
        filhos = undefined;
      }
      retorno.push({
        value: props.id,
        title: props.denominacao,
        disabled: permiteSintetico
          ? !props.ativo
          : planoContaFinanceiro
          ? props.idPai !== null && (props.sinteticoAnalitico?.toLowerCase() !== "s" || filhos !== undefined || !props.ativo)
          : centroCusto
          ? props.idPai !== null && (filhos !== undefined || !props.ativo)
          : props.sinteticoAnalitico?.toLowerCase() === "s" || filhos !== undefined || !props.ativo || props.idPai === null,
        children: generateTree(filhos),
        key: props.id,
      });
    });

    return retorno;
  };

  return (
    <TreeSelect
      showSearch
      value={value}
      maxTagCount="responsive"
      maxTagPlaceholder={(omittedValues) => (
        <Tooltip
          styles={{ root: { pointerEvents: "none" } }}
          title={
            <ul style={{ paddingLeft: 16, margin: 0 }}>
              {omittedValues.map((field, index) => (
                <li key={index}>{field.label}</li>
              ))}
            </ul>
          }
        >
          <span>{`+ ${omittedValues.length} ...`}</span>
        </Tooltip>
      )}
      treeNodeFilterProp="title"
      treeLine
      allowClear
      onChange={(selectedValue) => {
        onChange?.(selectedValue);
      }}
      loading={loading}
      style={style}
      treeData={generateTree(list)}
      {...props}
    />
  );
};

export default SelectTree;
